import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({ name: "s2t" })
export class SecondsToTime implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) {
      return;
    }
    return moment("2020-01-01").startOf("day").seconds(value).format("H:mm:ss");
  }
}
